module.exports = __webpack_public_path__ + "static/assets/5f6162237b9164725d1a85b3a12b9a64.png";